var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ClickAwayListener, Popper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { BPMSoundsGeneric } from '../../../generic';
import { EditGrid } from './Grid';
var alreadyLoadedTags = [];
var flatTagData = [];
var EditGridSelectTags = function (props) {
    var _a = useState([]), tags = _a[0], setTags = _a[1];
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(props.currentTags.map(function (t) { return t.id; })), selectedIds = _c[0], setSelectedIds = _c[1];
    useEffect(function () {
        setOpen(!props.closed);
    }, [props.closed]);
    var setCurrentTagDS = function () {
        setTags(alreadyLoadedTags.reduce(function (prev, current) {
            if (current.id == 'null-c') {
                prev.push(__assign(__assign({}, current), { items: current.items.map(function (item) {
                        return __assign(__assign({}, item), { selected: selectedIds.includes(item.id) });
                    }) }));
            }
            else {
                prev.push({
                    name: current.name,
                    items: current.items.reduce(function (prev, group) {
                        prev = prev.concat.apply(prev, group.items.map(function (item) {
                            return __assign(__assign({}, item), { selected: selectedIds.includes(item.id) });
                        }));
                        return prev;
                    }, [])
                });
            }
            return prev;
        }, []));
    };
    useEffect(function () {
        setSelectedIds(props.currentTags.map(function (t) { return t.id; }));
    }, [props.currentTags]);
    useEffect(function () {
        if (!props.closed) {
            if (alreadyLoadedTags.length == 0) {
                BPMSoundsGeneric.get().getTagCategories && BPMSoundsGeneric.get().getTagCategories().then(function (tags) {
                    alreadyLoadedTags = tags.slice();
                    setCurrentTagDS();
                    var flatTags = new Array();
                    tags.forEach(function (category) {
                        category.items.forEach(function (group) {
                            flatTags.push({ id: group.id, name: group.name });
                            if (group.items) {
                                group.items.forEach(function (tag) {
                                    flatTags.push({ id: tag.id, name: tag.name });
                                });
                            }
                        });
                        flatTagData = flatTags;
                    });
                });
            }
            else {
                setCurrentTagDS();
            }
        }
    }, [props.closed, selectedIds]);
    return (React.createElement(Popper, { anchorEl: props.anchor, placement: 'left', open: open, modifiers: {
            flip: {
                enabled: true,
            },
            preventOverflow: {
                enabled: true,
                boundariesElement: 'window',
            }
        }, style: { zIndex: 400 } },
        React.createElement(ClickAwayListener, { mouseEvent: 'onClick', onClickAway: function (event) {
                if (event.target.classList && event.target.classList.contains('prevent-tag-edit-close')) {
                    return;
                }
                props.onClosed(true);
            } },
            React.createElement("div", null,
                React.createElement(EditGrid, { allowSearch: true, items: tags, onItemClicked: function (tag) {
                        if (selectedIds.includes(tag)) {
                            props.onTagsSelected(props.currentTags.filter(function (t) { return t.id != tag; }));
                        }
                        else {
                            var newTag = flatTagData.find(function (t) { return t.id == tag; });
                            if (newTag) {
                                props.onTagsSelected(props.currentTags.concat(newTag));
                            }
                        }
                    } })))));
};
export default EditGridSelectTags;
//# sourceMappingURL=GridSelectTags.js.map